/** 前端 → API 小工具（一律 JSON；壞回應唔 throw，交由呼叫者判斷） */
export interface ApiResult<T> {
  ok: boolean;
  status: number;
  data: T | null;
}

async function call<T>(path: string, init?: RequestInit): Promise<ApiResult<T>> {
  try {
    const res = await fetch(path, init);
    let data: T | null = null;
    try {
      data = (await res.json()) as T;
    } catch {
      data = null;
    }
    return { ok: res.ok, status: res.status, data };
  } catch {
    return { ok: false, status: 0, data: null };
  }
}

export const apiGet = <T>(path: string): Promise<ApiResult<T>> => call<T>(path);

export const apiPost = <T>(path: string, body: unknown): Promise<ApiResult<T>> =>
  call<T>(path, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });

export const apiPatch = <T>(path: string, body: unknown): Promise<ApiResult<T>> =>
  call<T>(path, {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });

export const apiDelete = <T>(path: string): Promise<ApiResult<T>> => call<T>(path, { method: 'DELETE' });

/** 伺服器回嘅錯誤字串（有就攞；唔當係 UI 文案） */
export const errOf = (data: unknown): string => {
  if (data && typeof data === 'object' && 'error' in data) {
    const e = (data as { error?: unknown }).error;
    if (typeof e === 'string') return e;
  }
  return '';
};

/**
 * 伺服器回嘅**機器可讀原因**（例 `not_member`／`not_verified`／`inactive`）。
 * ⚠️ UI 靠佢決定流程（例：唔係會員 → 直接跳去登記頁），**唔准靠訊息字串比對**。
 */
export const reasonOf = (data: unknown): string | undefined => {
  if (data && typeof data === 'object' && 'reason' in data) {
    const r = (data as { reason?: unknown }).reason;
    if (typeof r === 'string' && r) return r;
  }
  return undefined;
};
